import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { PhoneNumberPriceHistoryInterface } from '../../store/callrecorder/phoneNumberPriceHistoriesSlice';

const PREFIX = 'callrecorder';

export const phoneNumberPriceHistoriesEntity = new schema.Entity('phone_number_price_histories');

const fetchCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params });
  const normalized = normalize<
    any,
    { phone_number_price_histories: { [key: string]: PhoneNumberPriceHistoryInterface } }
  >(response.data.phone_number_price_histories, [phoneNumberPriceHistoriesEntity]);

  return {
    phoneNumberPriceHistories: normalized.entities?.phone_number_price_histories || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchPhoneNumberPriceHistories = createAsyncThunk(
  `${PREFIX}_phone_number_price_histories/fetchPhoneNumberPriceHistories`,
  async (params: object = {}) => fetchCollection('/onesky/phone_number_price_histories', params)
);
